import { moment } from '../../main';
import utilities from '../../utils/utilities';

// initial state
const state = {
    visible: false,
    title: '',
    handlerAction: null,
    handlerActionParams: null,
    showTime: false,
    monthTitle: '',
    month: null,
    weekdays: [],
    days: [],
    hours: [],
    times: [],
    time: null,
    hourFormat: 'H',
    date: null
};

// mutations
const mutations = {
    show(state) {
        state.visible = true;
    },
    hide(state) {
        state.visible = false;
    },
    title(state, title) {
        state.title = title;
    },
    handlerAction(state, handlerAction) {
        state.handlerAction = handlerAction;
    },
    handlerActionParams(state, handlerActionParams) {
        state.handlerActionParams = handlerActionParams;
    },
    showTime(state, showTime) {
        state.showTime = showTime;
    },
    date(state, date) {
        state.date = date;
    },
    monthTitle(state, monthTitle) {
        state.monthTitle = monthTitle;
    },
    month(state, month) {
        state.month = month;
    },
    weekdays(state, weekdays) {
        state.weekdays = weekdays;
    },
    days(state, days) {
        state.days = days;
    },
    deselectDays(state) {
        for (let i = 0; i < 42; i++) {
            state.days[i].isSelected = false;
        }
    },
    selectDay(state, index) {
        state.days[index].isSelected = true;
    },
    hours(state, hours) {
        state.hours = hours;
    },
    times(state, times) {
        state.times = times;
    },
    time(state, time) {
        state.time = time;
    },
    hourFormat(state, hourFormat) {
        state.hourFormat = hourFormat;
    }
};

export const functions = {
    local(store, date) {
        return moment.tz(date, store.rootState.settings.account.timezone);
    },
    loadDates(store, date) {
        store.commit('monthTitle', date.format('MMMM YYYY'));

        const currentMonth = date.month();
        date.startOf('week');
        const days = [];
        for (let i = 0; i < 42; i++) {
            days.push({
                name: date.format('D'),
                isCurrentMonth: date.month() === currentMonth,
                date: date.clone(),
                isSelected: store.state.date ? date.isSame(store.state.date, 'day') : false
            });
            date.add(1, 'd');
        }
        store.commit('days', days);
    },
    loadHours(store, date) {
        const nextDay = date.clone().add(1, 'd');
        const hours = [];

        const timesDate = date.clone();
        const times = [];

        while (date.diff(nextDay) < 0) {
            hours.push(date.format(store.state.hourFormat));
            date.add(1, 'h');
        }

        let timeIndex = 0;
        let position = 0;
        let selectedTimeIndex = 0;

        while (timesDate.diff(nextDay) < 0) {
            if (timesDate.isSame(store.state.date)) {
                selectedTimeIndex = timeIndex;
            }

            times.push({
                title: timesDate.format('LT'),
                date: timesDate.clone(),
                position: (position * 100) / 48,
                index: timeIndex
            });
            timeIndex++;

            position++;
            timesDate.add(30, 'm');
        }
        store.commit('times', times);
        store.commit('time', times[selectedTimeIndex]);
        store.commit('hours', hours);
    }
};

// actions
const actions = {
    init(store) {
        const weekdays = [];
        for (let i = 0; i < 7; i++) {
            weekdays.push(moment().weekday(i).format('dd'));
        }
        store.commit('weekdays', weekdays);

        const hourFormat = store.rootState.settings.account.culture === 'en' ? 'h' : 'H';

        store.commit('hourFormat', hourFormat);
    },
    open(store, { dateString, title, handlerAction, handlerActionParams, showTime }) {
        const date = utilities.convertStringToDate(store, dateString, false, store.state.showTime ? 'L LT' : 'L');
        const dateMoment = date ? moment(date) : moment();

        store.commit('title', title);
        store.commit('handlerAction', handlerAction);
        store.commit('handlerActionParams', handlerActionParams);
        store.commit('showTime', showTime);
        store.commit('date', dateMoment);

        //loading day hours
        const dayStart = dateMoment.clone().startOf('day');
        functions.loadHours(store, dayStart.clone());

        //loading month dates
        const monthStart = dateMoment.clone().startOf('month');
        store.commit('month', monthStart.clone());
        functions.loadDates(store, monthStart);

        store.commit('show');
    },
    nextMonth(store) {
        const nextMonth = store.state.month.clone().add(1, 'M');
        store.commit('month', nextMonth);
        functions.loadDates(store, nextMonth.clone());
    },
    previousMonth(store) {
        const nextMonth = store.state.month.clone().subtract(1, 'M');
        store.commit('month', nextMonth);
        functions.loadDates(store, nextMonth.clone());
    },
    pickDay(store, payload) {
        store.commit('deselectDays');
        store.commit('selectDay', payload.index);
        functions.loadHours(store, payload.date.clone());
    },
    nextTime(store) {
        if (store.state.time.index < store.state.times.length - 1) {
            store.commit('time', store.state.times[store.state.time.index + 1]);
        }
    },
    previousTime(store) {
        if (store.state.time.index > 0) {
            store.commit('time', store.state.times[store.state.time.index - 1]);
        }
    },
    pickTime(store, event) {
        let x = !!event.touches ? event.touches[0].pageX : event.pageX;
        let offset = 0;
        let ref = event.currentTarget;

        while (ref) {
            offset += ref.offsetLeft;
            ref = ref.offsetParent;
        }

        const position = (x - offset) / event.currentTarget.offsetWidth;

        const positionPercent = position * 100;
        if (store.state.times.length > 0) {
            const time = store.state.times[0];
            let diff = Math.abs(time.position - positionPercent);
            let index = 0;
            for (let i = 1; i < store.state.times.length; i++) {
                const newDiff = Math.abs(store.state.times[i].position - positionPercent);
                if (newDiff < diff) {
                    diff = newDiff;
                } else {
                    break;
                }
                index = i;
            }
            store.commit('time', store.state.times[index]);
        }
    },
    hide(store) {
        store.commit('hide');
    },
    ok(store) {
        store.dispatch(store.state.handlerAction,
            {
                dateString: moment.tz(store.state.time.date, store.rootState.settings.account.timezone).format(store.state.showTime ? 'L LT' : 'L'),
                date: store.state.time.date,
                params: store.state.handlerActionParams
            },
            { root: true });
        store.commit('hide');
    }
};

// getters
const getters = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/dateTimePicker.js